import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { useBusinessCard } from 'components/BusinessCard/context'
import { Section, Row } from 'components/BusinessCard/components/StyledComponents'
import { H6, P, spacing } from '@PipelineDeals/shared-react-components'

const MilestoneRow = styled(Row)`
  justify-content: flex-start;
  gap: ${spacing.sm};
`

const StatusIndicator = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.color ? `#${props.color}` : props.theme.colors.gray[400]};
  flex-shrink: 0;
`

const MilestoneName = styled(P)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const MilestoneStatus = styled.span`
  color: ${({ theme }) => theme.colors.gray[500]};
  font-size: 12px;
  flex-shrink: 0;
`

const ProjectMilestones = () => {
  const { t } = useTranslation()
  const {
    cardMeta: { showOnlyFields },
    resource: project
  } = useBusinessCard()

  if (!showOnlyFields.includes('project_milestones')) return null
  if (!project.project_milestones?.length) return null

  return (
    <Section>
      <H6>{t('businessCard.labels.milestones')}</H6>
      {project.project_milestones.map(milestone => (
        <MilestoneRow key={milestone.id}>
          <StatusIndicator color={milestone.status_color} />
          <MilestoneName>{milestone.name}</MilestoneName>
          {milestone.status && (
            <MilestoneStatus>({milestone.status})</MilestoneStatus>
          )}
        </MilestoneRow>
      ))}
    </Section>
  )
}

export default ProjectMilestones
